"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Briefcase = function Briefcase(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M18.25 18.25H5.75c-.69 0-1.25-.56-1.25-1.25v-4.52a.478.478 0 01.745-.397A3.098 3.098 0 007 12.625h3.75v.651c0 .27.5.599 1.25.599s1.25-.329 1.25-.599v-.651H17c.626 0 1.238-.188 1.755-.542a.478.478 0 01.745.397V17c0 .69-.56 1.25-1.25 1.25zM17 12h-3.75v-.625a.312.312 0 00-.313-.313h-1.874a.312.312 0 00-.313.313V12H7a2.5 2.5 0 01-2.5-2.5V8.25C4.5 7.56 5.06 7 5.75 7h2.813v-.938c0-.862.7-1.562 1.562-1.562h3.75c.863 0 1.563.7 1.563 1.563V7h2.812c.69 0 1.25.56 1.25 1.25V9.5A2.5 2.5 0 0117 12zm-2.813-5.938a.312.312 0 00-.312-.312h-3.75a.313.313 0 00-.313.313V7h4.376v-.938z"
  }));
};

var _default = (0, _react.forwardRef)(Briefcase);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Briefcase, "Briefcase", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Briefcase.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Briefcase.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();